import LinkBlock from './LinkBlock';

export default LinkBlock;
